export default __webpack_public_path__ + "static/lxl-lgbt-809f3082e931532b7c422fc346f3a633.webp";